import { Box, Row, Text, TextWithTooltip } from "@hightouch/htui";

import {
  getColumnTypeIcon,
  getColumnTypeLabel,
} from "src/pages/schema/columns/columns-utils";

type Props = {
  type: string;
  isStale?: boolean;
};

export function ColumnTypeCell({ type, isStale = false }: Props) {
  if (isStale) {
    return (
      <Text size="sm" color="text.tertiary">
        —
      </Text>
    );
  }

  const ColumnTypeIcon = getColumnTypeIcon(type);
  return (
    <Row align="center" gap={2} width="100%">
      <Box as={ColumnTypeIcon} color="text.secondary" fontSize="lg" />
      <TextWithTooltip>{getColumnTypeLabel(type)}</TextWithTooltip>
    </Row>
  );
}
